import React from 'react';

import { DrmErrorUnknown } from './unknown';

export const DrmErrorUnsupported = () => <DrmErrorUnknown isErrorUnknown={false} />;
